import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-storyboards-view',
  templateUrl: './storyboards-view.component.html',
  styleUrls: ['./storyboards-view.component.scss']
})
export class StoryboardsViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
